"use client";

import { c as _c } from "react/compiler-runtime";
import type { CampaignPageSection } from "@growwithai/shared";
import SafeImage from "@/components/common/SafeImage";
import { sectionBgStyle, sectionHeadingStyle } from "../section-style";
type TeachersProps = Extract<CampaignPageSection, {
  type: "teachers";
}>;

/** Kartu profil pengajar: foto bulat / inisial + nama + peran + bio singkat. */
export default function TeachersSection(t0) {
  const $ = _c(18);
  const {
    section
  } = t0;
  if (section.items.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== section.custom_style) {
    t1 = sectionBgStyle(section.custom_style);
    $[0] = section.custom_style;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== section.custom_style) {
    t2 = sectionHeadingStyle(section.custom_style);
    $[2] = section.custom_style;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = section.heading ?? "Pengajar Kami";
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <h2 className="text-center text-2xl font-bold tracking-tight text-warm-black md:text-3xl" style={t2}>{t3}</h2>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = `mt-8 grid gap-5 sm:grid-cols-2 ${section.items.length >= 4 ? "lg:grid-cols-4" : "lg:grid-cols-3"}`;
  let t6;
  if ($[7] !== section.items) {
    t6 = section.items.map(_temp);
    $[7] = section.items;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t4 || $[13] !== t7) {
    t8 = <div className="mx-auto max-w-6xl px-5">{t4}{t7}</div>;
    $[12] = t4;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t1 || $[16] !== t8) {
    t9 = <section className="bg-warm-cream py-14 md:py-20" style={t1}>{t8}</section>;
    $[15] = t1;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}
function _temp(item, i) {
  return <div key={i} className="flex flex-col items-center rounded-2xl border [border-color:var(--card-border-color,rgba(0,0,0,.06))] bg-white p-6 text-center shadow-[var(--card-shadow,none)] [backdrop-filter:var(--card-backdrop,none)]">{item.photo_url ? <SafeImage src={item.photo_url} alt={item.name} loading="lazy" className="h-24 w-24 rounded-full border-2 border-[var(--brand-primary)]/15 object-cover" /> : <span className="flex h-24 w-24 items-center justify-center rounded-full bg-[var(--brand-primary)]/10 text-3xl font-bold text-[var(--brand-primary)]">{item.name.charAt(0).toUpperCase()}</span>}<p className="mt-4 text-[15px] font-semibold text-warm-black">{item.name}</p>{item.role && <p className="mt-0.5 text-xs font-medium text-[var(--brand-primary)]">{item.role}</p>}{item.bio && <p className="mt-2 text-[13px] leading-relaxed text-gray-500">{item.bio}</p>}</div>;
}